import { assert } from "@vue/compiler-core"
import { cloneDeep } from 'lodash'

export const computeAsserted = (asserted, missing, isIssuePresent) => {
  if (missing) {
    return null
  }
  if (isIssuePresent) {
    return false
  }
  if (asserted === false) {
    return true
  }
  return asserted
}

export const normalizeReport = (report) => {
  try {
    const result = cloneDeep(report)
    assert(Array.isArray(result.issues), 'Bad argument report.issues')
    assert(Array.isArray(result.checkpoints), 'Bad argument report.checkpoints')

    result.checkpoints = result.checkpoints.map((checkpoint) => {
      const issues = result.issues.filter((issue) => Number(issue.checkpoint.id) === Number(checkpoint.id))
      const isIssuePresent = issues.length > 0
      checkpoint.asserted = computeAsserted(checkpoint.asserted, checkpoint.missing, isIssuePresent)
      return checkpoint
    })

    return result
  } catch (err) {
    console.log('error normalizeReport', report)
    return null
  }
}
